import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";

import { cn } from "@lib/utils";

/** Visually or semantically separates content.
 * @prop className - The class name to apply to the separator.
 * @prop orientation - The orientation of the separator.
 */
export const Separator = ({ className, orientation = "horizontal", ...props }: SeparatorPrimitive.Props) => (
	<SeparatorPrimitive
		data-slot="separator"
		orientation={orientation}
		className={cn(
			`shrink-0 bg-secondary data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full
			data-[orientation=vertical]:h-auto data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch`,
			className,
		)}
		{...props}
	/>
);

Separator.displayName = "Separator";
